// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Comfirmapprove/alert.css
// module id = 1937
// module chunks = 193